import { render } from "./SelecionarProdutoFrenteCaixa.vue?vue&type=template&id=2956585e&scoped=true&ts=true"
import script from "./SelecionarProdutoFrenteCaixa.vue?vue&type=script&lang=ts"
export * from "./SelecionarProdutoFrenteCaixa.vue?vue&type=script&lang=ts"

import "./SelecionarProdutoFrenteCaixa.vue?vue&type=style&index=0&id=2956585e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2956585e"]])

export default __exports__